import KycButton from '../Button/Button'
import React from 'react'

interface FooterButtonsProps {
  isDisabled?: boolean
  isLoading?: boolean
  handleSearch?: () => void
  handleClose?: () => void
  setShow: (value: boolean) => void
  searchChildren?: string
  searchClose?: string
}

const FooterButtons: React.FC<FooterButtonsProps> = ({
  isDisabled,
  isLoading,
  handleSearch,
  handleClose,
  setShow,
  searchChildren = 'Search',
  searchClose = 'Close',
}) => {
  const onClose = () => {
    if (handleClose) {
      return handleClose()
    }
    setShow(false)
  }
  return (
    <div className="footer-btns">
      <>
        {searchChildren && handleSearch && (
          <KycButton
            className="m-l-10"
            variant={'outline-primary'}
            children={searchChildren}
            isLoading={isLoading}
            onClick={handleSearch}
            // disabled={isDisabled}
          />
        )}
      </>

      <KycButton
        className="m-l-10"
        onClick={onClose}
        variant={'outline-primary'}
        children={searchClose}
        size="lg"
      />
    </div>
  )
}

export default FooterButtons
